import Vue from "vue";
import Bublina from "../vue/Bublina.vue";

function zobraz() {
  if (!$("#dvBubl").length) {
    $("<div/>", { id: "dvBubl" }).appendTo("#header .navigation-buttons");
  }

  Vue.config.productionTip = false;

  new Vue({
    render: h => h(Bublina)
  }).$mount("#dvBubl");
}

export { zobraz };
